export default function HeaderLogo(): JSX.Element {
  return (
    <a href="#about" className="header-logo">
      <span>{"<"}</span>AB<span>{" />"}</span>
    </a>
  );
}
